import React, { Component } from 'react';
import FormicaInput from '../../../../custom/FormicaInput';
import RoleHelper from '../../../../../RoleHelper';
import FormicaSearchSelectBox, { FormicaSelectBoxItem } from '../../../../custom/FormicaSearchSelectBox';
import { AlarmCloseCodeStatus, CaseSettings } from '../../../../../domain/case/CaseDomains';
import MessageUtil from '../../../../../util/MessageUtil';
import { AnimatedButton } from '@trlogic/ui-pack';
import { RootState } from '../../../../../redux/store';
import { User } from '../../../../../domain/rbac/RbacDomains';
import { connect } from 'react-redux';
import { ConnectedProps } from 'react-redux/es/exports';
import LanguageUtil from '../../../../../util/LanguageUtil';

class DomainConfigurationReasonCreatorComponent extends Component<Props, State> {
  public state: State = new State();

  public render() {
    const { code, status } = this.state;
    const { user } = this.props;

    return (
      <div className={'w-full flex flex-col lg:flex-row justify-around items-center mt-5 mb-5 gap-y-5 gap-x-5'}>
        <div className={'w-full flex'}>
          <FormicaInput
            onChange={(e: React.FormEvent<HTMLInputElement>) => this.onChangeCode(e)}
            value={code}
            name={'Name'}
            label={LanguageUtil.get({ id: 'common.label.name', defaultMessage: 'Name' })}
            placeholder={LanguageUtil.get({ id: 'common.input.placeholder.name', defaultMessage: 'Name' })}
            type={'text'}
            disabled={!RoleHelper.canEdit('CaseConfiguration')}
          />
        </div>
        <div className={'w-full group flex gap-x-5 gap-y-5'}>
          <FormicaSearchSelectBox
            placeholder={LanguageUtil.get({ id: 'common.input.placeholder.status', defaultMessage: 'Status' })}
            value={status}
            disabled={!RoleHelper.canEdit('CaseConfiguration')}
            rounded
            onChange={(e: FormicaSelectBoxItem) => this.onChangeStatus(e)}
            options={[
              {
                label:
                  user.activeRiskType == 'fraud'
                    ? LanguageUtil.get({
                        id: 'common.label.fraud',
                        defaultMessage: 'Fraud',
                      })
                    : LanguageUtil.get({ id: 'common.label.inCompliant', defaultMessage: 'In Compliant' }),
                value: user.activeRiskType == 'fraud' ? 'FRAUD' : 'IN_COMPLIANT',
              },
              {
                label:
                  user.activeRiskType == 'fraud'
                    ? LanguageUtil.get({ id: 'common.label.notFraud', defaultMessage: 'No Fraud' })
                    : LanguageUtil.get({ id: 'common.label.compliant', defaultMessage: 'Compliant' }),
                value: user.activeRiskType == 'fraud' ? 'NOT_FRAUD' : 'COMPLIANT',
              },
              {
                label: LanguageUtil.get({ id: 'common.label.onHold', defaultMessage: 'On Hold' }),
                value: 'HOLD',
              },
            ]}
          />
        </div>
        <div className={'h-full flex justify-center items-center'}>
          <AnimatedButton
            text={LanguageUtil.get({ id: 'common.button.add', defaultMessage: 'Add' })}
            icon={'add'}
            customSize={'sm'}
            customType={'primary'}
            onClick={this.addVariable}
            disabled={!RoleHelper.canEdit('Transaction')}
          />
        </div>
      </div>
    );
  }

  private onChangeCode = (e: React.FormEvent<HTMLInputElement>) => {
    this.setState({ code: (e.target as HTMLInputElement).value });
  };

  private onChangeStatus = (e: FormicaSelectBoxItem) => {
    this.setState({ status: e.value });
  };

  private addVariable = () => {
    const { code, status } = this.state;
    const { changeDomain, domainConfiguration } = this.props;

    if (code != undefined && code.length == 0) {
      return MessageUtil.warning({
        summary: LanguageUtil.get({ id: 'common.label.configurationReason', defaultMessage: 'Configuration Reason' }),
        detail: <div>{LanguageUtil.get({ id: 'pages.configuration.panel.reasonDetailCode', defaultMessage: 'Reason name can not null' })}</div>,
      });
    } else if (status != undefined && status.length == 0) {
      return MessageUtil.warning({
        summary: LanguageUtil.get({ id: 'common.label.configurationReason', defaultMessage: 'Configuration Reason' }),
        detail: <div>{LanguageUtil.get({ id: 'pages.configuration.panel.reasonDetailStatus', defaultMessage: 'Reason status can not null' })}</div>,
      });
    } else {
      if (code && status) {
        const existingReason = domainConfiguration.closeCodes.find((reason) => reason.code === code);
        if (existingReason) {
          existingReason.status = status;
        } else {
          const reason = { code, status };
          domainConfiguration.closeCodes.push(reason);
        }
        changeDomain(domainConfiguration);
        this.setState({ code: '', status: undefined });
        return MessageUtil.success({
          summary: LanguageUtil.get({ id: 'common.label.reason', defaultMessage: 'Reason' }),
          detail: <div>{LanguageUtil.get({ id: 'pages.configuration.panel.reasonCreated', defaultMessage: 'Reason created.' })}</div>,
        });
      }
    }
  };
}

class State {
  code: string | undefined;
  status: AlarmCloseCodeStatus | undefined;
}

interface Props extends ReduxProps {
  domainConfiguration: CaseSettings;
  changeDomain: (domain: CaseSettings) => void;
}

const mapStateToProps = (state: RootState) => ({
  user: state.auth.user as User,
});
const connector = connect(mapStateToProps);
type ReduxProps = ConnectedProps<typeof connector>;

export default connector(DomainConfigurationReasonCreatorComponent);
